import React, { useState, useEffect, useCallback } from 'react'
import { Form, Message, Button } from 'semantic-ui-react'
import history from '~/services/history'
import { toast } from 'react-toastify'

import api from '../../services/api'
import { useGlobalContext } from '../../contexts/GlobalContext'
import { SemanticContainer } from './styles'
import SearchableSelect from './components/SearchableSelect'

export default function ContatoMerge({ location }) {
  const { globalDispatch } = useGlobalContext()
  const search = new URLSearchParams(location.search)

  const [did, _] = useState(search.get('did') || '')
  const [nome, setNome] = useState('')

  const [searchTerm, setSearchTerm] = useState('')
  const [campoCustom, setCampoCustom] = useState('')
  const [contatos, setContatos] = useState([])
  const [selectedContact, setSelectedContact] = useState(null)

  const getContatos = useCallback(async () => {
    const { data } = await api.get('/contacts', {
      params: {
        descricao: searchTerm,
        campoCustom,
      },
    })
    setContatos(data.rows)
  }, [searchTerm, campoCustom])

  const handleAddNumberToContactAndBackToTicket = async () => {
    if (!selectedContact) {
      toast.error('Selecione um contato')
      return
    }

    try {
      await api.post(`/contacts/${selectedContact}/phones`, { number: did })
      globalDispatch({
        type: 'SET_DATA',
        payload: {
          tickets: [],
        },
      })
      history.push('/dashboard')
    } catch (error) {
      toast.error('Erro ao adicionar número ao contato')
    }
  }

  useEffect(() => {
    getContatos()
  }, [getContatos])

  return (
    <SemanticContainer>
      <Form>
        <Message>
          <Form.Input
            name="did"
            fluid
            label="Numero"
            placeholder="Numero"
            value={did || ''}
            // onChange={(e) => setDid(e.target.value)}
          />
        </Message>

        <Message>
          <Form.Input
            name="nome"
            fluid
            label="Nome"
            placeholder="Nome"
            value={nome || ''}
            // onChange={(e) => setNome(e.target.value)}
          />
        </Message>

        <Message
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
          }}
        >
          <SearchableSelect
            options={contatos.map((contato) => ({
              label: contato.descricao,
              value: contato.id,
            }))}
            value={searchTerm}
            onChange={(id) => {
              const contato = contatos.find((c) => c.id === id)
              if (contato) {
                setSelectedContact(contato.id)
                setNome(contato.descricao)
                setSearchTerm(contato.descricao)
              } else {
                setSelectedContact(null)
                setNome('')
              }
            }}
            placeholder="Procurar pelo Nome do Contato"
            itemsPerPage={6}
            searchTermFn={() => {}}
            onClick={() => {
              setSearchTerm('') // Reset search term when clicking the select
            }}
          />

          <SearchableSelect
            options={contatos.reduce((acc, contato) => {
              if (contato.ContactFields && contato.ContactFields.length > 0) {
                for (const field of contato.ContactFields) {
                  acc.push({
                    label: `${contato.descricao} - ${field.nome_campo}: ${field.conteudo}`,
                    value: contato.id,
                  })
                }
              }
              return acc
            }, [])}
            // options={tagOptions}
            value={campoCustom}
            onChange={(id) => {
              console.log(id)

              const contato = contatos.find((c) => c.id === id)
              if (contato) {
                setSelectedContact(contato.id)
                setNome(contato.descricao)
              } else {
                setSelectedContact(null)
                setNome('')
              }
            }}
            placeholder="Procurar por Parametros Customizados"
            itemsPerPage={6}
            searchTermFn={(event) => {
              setCampoCustom(event)
            }}
            onClick={() => {
              setCampoCustom('') // Reset search term when clicking the select
            }}
          />
        </Message>

        <Button
          fluid
          color="brown"
          type="button"
          onClick={() => {
            handleAddNumberToContactAndBackToTicket()
          }}
        >
          Mesclar
        </Button>
      </Form>
    </SemanticContainer>
  )
}
